import React from 'react';
import { default as ModalReact } from 'react-modal';
import styles from './Modal.module.scss';
import cn from 'classnames';

interface ModalProps extends Omit<ModalReact.Props, 'overlayClassName' | 'portalClassName'> {
  title?: string;
  actions?: React.ReactElement;
  customClassname?: string;
}

ModalReact.setAppElement('body');

export const Modal: React.FC<ModalProps> = ({ title, actions, children, customClassname, ...restProps }) => {
  return (
    <ModalReact
      overlayClassName={styles['o-modal']}
      className={cn(styles['o-modal__container'], customClassname)}
      shouldReturnFocusAfterClose
      shouldCloseOnEsc
      shouldCloseOnOverlayClick
      shouldFocusAfterRender
      {...restProps}
    >
      <div className={styles['o-modal__content']}>
        {title && <h1 className="text-3 leading-tight">{title}</h1>}
        <div>
          {children}
        </div>
      </div>
      {actions && <div className="flex justify-end space-x-3">{actions}</div>}
    </ModalReact>
  );
};
